export function JobsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/jobs.svg'"></ng-include>`
    }
}